import { Telemetry } from '@videoblocks/kafka-rest-client';

import { buildModalRestoreUrl, serializeModalState } from './stateUtils';

export const handlePurchaseCredits = ({
  selectedStockItem,
  selection,
  selectedUseCase,
  defaultPlaceholder,
  promptText,
  planId,
}) => {
  Telemetry.increment('ai.contentEdit.buttonClick.purchaseCredits');

  // Save current modal state to sessionStorage before redirecting
  if (selectedStockItem) {
    serializeModalState({
      stockItem: selectedStockItem,
      selection,
      selectedUseCase,
      defaultPlaceholder,
      promptText,
      timestamp: Date.now(),
    });
  }

  // Build redirect URL with videoEditModal query param
  const redirectUrl = buildModalRestoreUrl();
  const encodedRedirectUrl = encodeURIComponent(redirectUrl);

  window.location.href = `/video/upgrade-my-plan/${planId}?redirectAfterRegister=${encodedRedirectUrl}`;
};
